import { EyeIcon, EyeOffIcon } from "icons/outline";
import { useState } from "react";
import { Tooltip } from "ui";
import { maskText } from "../../utils/maskText";
import { snakeCaseToHumanReadable } from "../../utils/snakeCaseToHumanReadable";
import CopyIconButton from "../CopyIconButton";

type MaskedTextProps = {
  textKey: string;
  textValue: string;
  onCopyClick?: () => void;
  onRevealClick?: () => void;
};

export const MaskedText = ({
  textKey,
  textValue,
  onCopyClick,
  onRevealClick,
}: MaskedTextProps) => {
  const [isShown, setIsShown] = useState(false);
  return (
    <>
      <div className="flex flex-row items-center justify-between">
        <span className="text-sm font-normal capitalize text-foundations-subtle">
          {snakeCaseToHumanReadable(textKey)}
        </span>
        <div className="space-x-1">
          <Tooltip>
            <Tooltip.Trigger
              className="group"
              onClick={() => {
                setIsShown((prev) => !prev);
                onRevealClick?.();
              }}
            >
              {isShown ? (
                <EyeOffIcon className="h-4 w-4 stroke-2 text-foundations-subtler group-hover:text-foundations-subtle" />
              ) : (
                <EyeIcon className="h-4 w-4 stroke-2 text-foundations-subtler group-hover:text-foundations-subtle" />
              )}
            </Tooltip.Trigger>
            <Tooltip.Popup size="sm">
              {isShown ? "Hide" : "Reveal"}
            </Tooltip.Popup>
          </Tooltip>
          <CopyIconButton text={textValue} onClick={onCopyClick} />
        </div>
      </div>
      <textarea
        rows={3}
        value={isShown ? textValue : maskText(textValue)}
        readOnly
        className="mt-1 block w-full  resize-y rounded-md border border-foundations-subtle bg-foundations-default text-sm font-normal text-foundations-boldest shadow-sm outline-none focus:border-info-bold focus:outline-none focus:ring-info-bold"
      />
    </>
  );
};
